import { render, staticRenderFns } from "./correcto.vue?vue&type=template&id=42d46588&"
import script from "./correcto.vue?vue&type=script&lang=js&"
export * from "./correcto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports